import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { RunwayService } from '../service/runway.service';
var DeleteAreaObstacleComponent = /** @class */ (function () {
    function DeleteAreaObstacleComponent(_matDialogRef, data, _runwayService) {
        this._matDialogRef = _matDialogRef;
        this._runwayService = _runwayService;
        this.isLoading = false;
        this.obstalceId = data.obstacleId;
        this.airportId = data.airportId;
    }
    DeleteAreaObstacleComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
    };
    DeleteAreaObstacleComponent.prototype.close = function (data) {
        this._matDialogRef.close(data);
    };
    DeleteAreaObstacleComponent.prototype.delete = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.isLoading = true;
                        return [4 /*yield*/, this._runwayService.deleteObstacle(this.airportId, this.obstalceId)];
                    case 1:
                        _a.sent();
                        this.isLoading = false;
                        this.close({ success: true, obstacleId: this.obstalceId });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.close({ success: false, error: e_1 });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DeleteAreaObstacleComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    return DeleteAreaObstacleComponent;
}());
export { DeleteAreaObstacleComponent };
